import { viewModelBindWrapper, viewModelBindAllWrapper } from './bind';
export var getInitBind = function (opts) { return function ($w) {
    if (!$w) {
        throw new Error('Trying to initialize state without $w.');
    }
    return {
        $bindAll: viewModelBindAllWrapper($w, opts),
        $bind: viewModelBindWrapper($w, opts),
    };
}; };
//# sourceMappingURL=index.js.map